const accessRoute = {
  BI_METRIC: {
    path: "/bi-metric",
  },
};
export default accessRoute;
